export default __webpack_public_path__ + "static/media/coding4.6b213597.png";